import { render, staticRenderFns } from "./CompetitionsMapMarker.vue?vue&type=template&id=b87748fc&"
import script from "./CompetitionsMapMarker.vue?vue&type=script&lang=js&"
export * from "./CompetitionsMapMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b87748fc')) {
      api.createRecord('b87748fc', component.options)
    } else {
      api.reload('b87748fc', component.options)
    }
    module.hot.accept("./CompetitionsMapMarker.vue?vue&type=template&id=b87748fc&", function () {
      api.rerender('b87748fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CompetitionsMapMarker.vue"
export default component.exports